// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__3ZYlE","inputData":"Input_inputData__Hi+4N","input":"Input_input__EXhs6","underline":"Input_underline__u9qlT","underline2":"Input_underline2__WCsiy"};